import { render } from "./studioQuery.vue?vue&type=template&id=5ce95931&scoped=true"
import script from "./studioQuery.vue?vue&type=script&lang=js"
export * from "./studioQuery.vue?vue&type=script&lang=js"

import "./studioQuery.vue?vue&type=style&index=0&id=5ce95931&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce95931"]])

export default __exports__